import { Table } from '@mantine/core';
import { useState } from 'react';
import { KeyedRow } from '../../../components/KeyedRow';
import { formatToCurrency } from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { EodVatDto } from '../types/EodVatDto';

interface EodVatRowProps {
	originalEodVat: EodVatDto;
}

export function EodVatRow({ originalEodVat }: EodVatRowProps) {
	const [eodVat, setEodVat] = useState(originalEodVat);

	return (
		<>
			<KeyedRow>
				<Table.Td>{undefinedCheck(eodVat.branch)}</Table.Td>
				<Table.Td>{eodVat.dateTime}</Table.Td>
				<Table.Td>{undefinedCheck(eodVat.till)}</Table.Td>
				<Table.Td>{undefinedCheck(eodVat.operator)}</Table.Td>
				<Table.Td>{eodVat.items}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.gross)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.net)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.refunds)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.paidOut)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.cash)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.card)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.misc)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.discounts)}</Table.Td>
				<Table.Td>{formatToCurrency(eodVat.vat)}</Table.Td>
			</KeyedRow>
		</>
	);
}
